export const GET_CATEGORIES_FOR_ADMIN_REQUEST = 'GET_CATEGORIES_FOR_ADMIN_REQUEST'
export const GET_CATEGORIES_FOR_ADMIN_SUCCESS = 'GET_CATEGORIES_FOR_ADMIN_SUCCESS'
export const GET_CATEGORIES_FOR_ADMIN_FAIL = 'GET_CATEGORIES_FOR_ADMIN_FAIL'

export const GET_CATEGORY_REQUEST = 'GET_CATEGORY_REQUEST'
export const GET_CATEGORY_SUCCESS = 'GET_CATEGORY_SUCCESS'
export const GET_CATEGORY_FAIL = 'GET_CATEGORY_FAIL'

export const GET_CATEGORY_TAGS_REQUEST = 'GET_CATEGORY_TAGS_REQUEST'
export const GET_CATEGORY_TAGS_SUCCESS = 'GET_CATEGORY_TAGS_SUCCESS'
export const GET_CATEGORY_TAGS_FAIL = 'GET_CATEGORY_TAGS_FAIL'

export const ADD_CATEGORY_REQUEST = 'ADD_CATEGORY_REQUEST'
export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS'
export const ADD_CATEGORY_FAIL = 'ADD_CATEGORY_FAIL'

export const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST'
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_FAIL = 'UPDATE_CATEGORY_FAIL'

export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST'
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS'
export const DELETE_CATEGORY_FAIL = 'DELETE_CATEGORY_FAIL'

export const ADD_CATEGORY_TAG_REQUEST = 'ADD_CATEGORY_TAG_REQUEST'
export const ADD_CATEGORY_TAG_SUCCESS = 'ADD_CATEGORY_TAG_SUCCESS'
export const ADD_CATEGORY_TAG_FAIL = 'ADD_CATEGORY_TAG_FAIL'

export const REMOVE_CATEGORY_TAG_REQUEST = 'REMOVE_CATEGORY_TAG_REQUEST'
export const REMOVE_CATEGORY_TAG_SUCCESS = 'REMOVE_CATEGORY_TAG_SUCCESS'
export const REMOVE_CATEGORY_TAG_FAIL = 'REMOVE_CATEGORY_TAG_FAIL'

export const ARRANGE_CATEGORY_REQUEST = 'ARRANGE_CATEGORY_REQUEST'
export const ARRANGE_CATEGORY_SUCCESS = 'ARRANGE_CATEGORY_SUCCESS'
export const ARRANGE_CATEGORY_FAIL = 'ARRANGE_CATEGORY_FAIL'